import { useTheme, type ThemePref } from "@/hooks/useTheme";

// Light / Dark / System segmented control. Three explicit options rather
// than a binary toggle so "follow my OS" stays reachable after an override.

const SunIcon = (
  <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" aria-hidden="true">
    <circle cx="12" cy="12" r="4" />
    <path d="M12 2v2m0 16v2M4.9 4.9l1.4 1.4m11.4 11.4 1.4 1.4M2 12h2m16 0h2M4.9 19.1l1.4-1.4M17.7 6.3l1.4-1.4" />
  </svg>
);

const MoonIcon = (
  <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M21 12.8A9 9 0 1 1 11.2 3a7 7 0 0 0 9.8 9.8z" />
  </svg>
);

const SystemIcon = (
  <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <rect x="2" y="4" width="20" height="13" rx="2" />
    <path d="M8 21h8m-4-4v4" />
  </svg>
);

const OPTIONS: { value: ThemePref; label: string; icon: JSX.Element }[] = [
  { value: "light", label: "Light theme", icon: SunIcon },
  { value: "dark", label: "Dark theme", icon: MoonIcon },
  { value: "system", label: "Follow system theme", icon: SystemIcon },
];

export function ThemeToggle(): JSX.Element {
  const { pref, setPref } = useTheme();
  return (
    <div className="theme-toggle" role="group" aria-label="Color theme">
      {OPTIONS.map((opt) => (
        <button
          key={opt.value}
          type="button"
          className="theme-toggle-btn"
          aria-pressed={pref === opt.value}
          aria-label={opt.label}
          title={opt.label}
          onClick={() => setPref(opt.value)}
        >
          {opt.icon}
        </button>
      ))}
    </div>
  );
}
